import React, { Component } from 'react';
import format from 'date-fns/format';
import { Wrapper, Heading, Table } from './styles';
class Events extends Component {
  render() {
    const { events } = this.props;
    return (
      <Wrapper>
        <Heading>Dates</Heading>
        <Table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Venue</th>
              <th>Information</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event, index) => event.show && (
              <tr key={event.city + index}>
                <td>{format(new Date(event.date.seconds * 1000), 'dd/MM/yyyy')}</td>
                <td>{event.city}</td>
                <td>
                  {event.link ? (
                    <a href={event.link} target="_blank">
                      {event.location}
                    </a>
                  ) : (
                    event.location
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Wrapper>
    );
  }
}

export default Events;
